export const CreateEditReadyRosterTranslations = {
  en: {
    create_title: "Create Ready Roster",
    edit_title: "Edit Ready Roster",
    financial_information: "Financial Information",
    no_roster_statuses_available: "No roster statuses available",
    purse: "Purse",
    purse_tooltip_title: "Select the expected or offered purse range for the fight or opportunity.",
    purse_tooltip_description: "This helps filter realistic offers and set expectations early.",
    currency: "Currency",
    select_purse_placeholder: "Select Purse",
    no_purse_options: "No purse options",
    select_currency_placeholder: "Select Currency",
    sport_information: "Sport Information",
    sports: "Sports",
    sports_tooltip_title: "Select the combat sport this card is related to.",
    sports_tooltip_description: "It defines the discipline you're available for.",
    level: "Level",
    level_tooltip_title: "Choose the competition level or ruleset that applies to this card.",
    level_tooltip_description: "It helps match fighters and events by experience level and regulations.",
    select_sport_placeholder: "Select Sport",
    select_level_placeholder:"Select Level",
    no_sports_available: "No sports available",
    weight_class: "Weight Class",
    weight_class_tooltip_title: "Select the weight division relevant to this card.",
    weight_class_tooltip_description: "It defines your fighting category",
    select_weight_class_placeholder: "Select Weight Class",
    no_weight_classes_available: "No weight classes available",
    valid_upto: "Valid Upto",
    valid_upto_tooltip_title: "Shows how long this card will remain active and visible to other users.",
    valid_upto_tooltip_description: "Once expired, it won’t appear in searches or listings.",
    select_valid_upto_placeholder: "Select valid upto months",
    one_month: "1 Month",
    two_months: "2 Months",
    three_months: "3 Months",
    location_travel_availability: "Location, Travel & Availability",
    roster_status: "Roster Status",
    Ready_updated_success:"Ready Roster Updated successfully",
    Ready_Created_success:"Ready Roster Created successfully",
   ready_roster_deleted_success :"Ready roster deleted successfully",
    select_roster_status_placeholder: "Select Roster Status",
    location: "Location",
    location_tooltip_title: "Displays the main location where the fight or opportunity is expected to take place.",
    location_tooltip_description: "Used for matchmaking, travel planning, and regional relevance.",
    available_regions: "Available regions",
    available_regions_tooltip_title: "Shows the countries or regions where the user is open to fighting, working, or collaborating.",
    available_regions_tooltip_description: "Useful for filtering based on geographic flexibility.",
    select_available_regions_placeholder: "Select Available Regions",
    notice_period_days: "Notice Period (Days)",
    enter_notice_period_placeholder: "Enter notice period",
    travel_ready: "Travel Ready?",
    available_days: "Available Days",
    select_date_range:"Date Range",
    dates : " date",
    selected:"selected",
    additional_information: "Additional Information",
    notes: "Notes",
    enter_notes_placeholder: "Enter additional notes...",
    characters: "1000 characters",
    cancel: "Cancel",
    save: "Save",
    selected_range:"seleceted Range",
    total_days:"Total days",
    purse_required: "Purse is required",
    currency_required: "Currency is required",
    sport_required: "Sport is required",
    level_required: "Level is required",
    weight_class_required: "Weight class is required",
    valid_upto_required: "Valid upto date is required",
    valid_upto_future: "Valid upto date must be in the future",
    location_required: "Location is required",
    available_regions_required: "At least one region must be selected",
    available_days_required: "At least one day must be selected",
    roster_status_required: "Roster status is required",
    failed_load_dropdown_data: "Failed to load dropdown data",
    failed_load_initial_data: "Failed to load initial data",
    failed_load_purse_options: "Failed to load purse options",
    failed_load_training_disciplines: "Failed to load training disciplines",
    failed_load_weight_classes: "Failed to load weight classes",
    failed_load_currency_options: "Failed to load currency options",
    failed_save_roster: "Failed to save roster",
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    amateur: "Amateur",
    semi_pro: "Semi-Pro",
    professional: "Professional",
    northern_africa: "Northern Africa",
    sub_saharan_africa: "Sub-Saharan Africa",
    eastern_africa: "Eastern Africa",
    middle_africa: "Middle Africa",
    southern_africa: "Southern Africa",
    western_africa: "Western Africa",
    northern_america: "Northern America",
    central_america: "Central America",
    south_america: "South America",
    caribbean: "Caribbean",
    central_asia: "Central Asia",
    eastern_asia: "Eastern Asia",
    southern_asia: "Southern Asia",
    south_eastern_asia: "South-Eastern Asia",
    western_asia: "Western Asia",
    eastern_europe: "Eastern Europe",
    northern_europe: "Northern Europe",
    southern_europe: "Southern Europe",
    western_europe: "Western Europe",
    australia_and_new_zealand: "Australia and New Zealand",
    melanesia: "Melanesia",
    micronesia: "Micronesia",
    polynesia: "Polynesia",
  },
  de: {
    select_date_range: "Datumsbereich",
    no_roster_statuses_available: "Keine Roster-Status verfügbar",
    create_title: "Bereitschaftsroster erstellen",
    edit_title: "Bereitschaftsroster bearbeiten",
    financial_information: "Finanzielle Informationen",
    purse: "Börse",
    purse_tooltip_title: "Wählen Sie den erwarteten oder angebotenen Börsenbereich für den Kampf oder die Gelegenheit aus.",
    purse_tooltip_description: "Dies hilft, realistische Angebote zu filtern und frühzeitig Erwartungen zu setzen.",
    currency: "Währung",
    select_purse_placeholder: "Börse auswählen",
    no_purse_options: "Keine Börsenoptionen",
    select_currency_placeholder: "Währung auswählen",
    sport_information: "Sportinformationen",
    select_level_placeholder: 'Level auswählen',
    sports: "Sportarten",
    Ready_updated_success: 'Bereitstellungsliste erfolgreich aktualisiert',
    Ready_Created_success: 'Bereitstellungsliste erfolgreich erstellt',
        ready_roster_deleted_success: "Bereitschaftsaufstellung erfolgreich gelöscht",
    sports_tooltip_title: "Wählen Sie die Kampfsportart aus, auf die diese Karte bezogen ist.",
    sports_tooltip_description: "Sie definiert die Disziplin, für die Sie verfügbar sind.",
    level: "Stufe",
    level_tooltip_title: "Wählen Sie die Wettkampfstufe oder das Regelwerk aus, das auf diese Karte zutrifft.",
    level_tooltip_description: "Es hilft, Kämpfer und Veranstaltungen nach Erfahrungsstand und Vorschriften abzustimmen.",
    select_sport_placeholder: "Sportart auswählen",
    no_sports_available: "Keine Sportarten verfügbar",
    weight_class: "Gewichtsklasse",
    weight_class_tooltip_title: "Wählen Sie die Gewichtsdivision aus, die für diese Karte relevant ist.",
    weight_class_tooltip_description: "Sie definiert Ihre Kampfkategorie",
    select_weight_class_placeholder: "Gewichtsklasse auswählen",
    no_weight_classes_available: "Keine Gewichtsklassen verfügbar",
    valid_upto: "Gültig bis",
    valid_upto_tooltip_title: "Zeigt an, wie lange diese Karte aktiv und für andere Benutzer sichtbar bleibt.",
    valid_upto_tooltip_description: "Nach Ablauf wird sie nicht mehr in Suchen oder Listen angezeigt.",
    select_valid_upto_placeholder: "Gültig bis Monate auswählen",
    one_month: "1 Monat",
    two_months: "2 Monate",
    three_months: "3 Monate",
    location_travel_availability: "Ort, Reisen & Verfügbarkeit",
    roster_status: "Roster-Status",
    select_roster_status_placeholder: "Roster-Status auswählen",
    location: "Ort",
    location_tooltip_title: "Zeigt den Hauptort an, an dem der Kampf oder die Gelegenheit stattfinden soll.",
    location_tooltip_description: "Wird für Matchmaking, Reiseplanung und regionale Relevanz verwendet.",
    available_regions: "Verfügbare Regionen",
    available_regions_tooltip_title: "Zeigt die Länder oder Regionen an, in denen der Benutzer bereit ist zu kämpfen, zu arbeiten oder zusammenzuarbeiten.",
    available_regions_tooltip_description: "Nützlich für die Filterung nach geografischer Flexibilität.",
    select_available_regions_placeholder: "Verfügbare Regionen auswählen",
    notice_period_days: "Kündigungsfrist (Tage)",
    enter_notice_period_placeholder: "Kündigungsfrist eingeben",
    travel_ready: "Reisebereit?",
    available_days: "Verfügbare Tage",
    dates: " Tag",
    selected: "ausgewählt",
    additional_information: "Zusätzliche Informationen",
    notes: "Notizen",
    enter_notes_placeholder: "Zusätzliche Notizen eingeben...",
    characters: "1000 Zeichen",
    cancel: "Abbrechen",
    save: "Speichern",
    purse_required: "Börse ist erforderlich",
    currency_required: "Währung ist erforderlich",
    sport_required: "Sportart ist erforderlich",
    level_required: "Stufe ist erforderlich",
    weight_class_required: "Gewichtsklasse ist erforderlich",
    valid_upto_required: "Gültig bis Datum ist erforderlich",
    valid_upto_future: "Gültig bis Datum muss in der Zukunft liegen",
    location_required: "Ort ist erforderlich",
    available_regions_required: "Mindestens eine Region muss ausgewählt sein",
    available_days_required: "Mindestens ein Tag muss ausgewählt sein",
    roster_status_required: "Roster-Status ist erforderlich",
    failed_load_dropdown_data: "Fehler beim Laden der Dropdown-Daten",
    failed_load_initial_data: "Fehler beim Laden der initialen Daten",
    failed_load_purse_options: "Fehler beim Laden der Börsenoptionen",
    failed_load_training_disciplines: "Fehler beim Laden der Trainingsdisziplinen",
    failed_load_weight_classes: "Fehler beim Laden der Gewichtsklassen",
    failed_load_currency_options: "Fehler beim Laden der Währungsoptionen",
    failed_save_roster: "Fehler beim Speichern des Rosters",
    january: "Januar",
    february: "Februar",
    march: "März",
    april: "April",
    may: "Mai",
    june: "Juni",
    july: "Juli",
    august: "August",
    september: "September",
    october: "Oktober",
    november: "November",
    december: "Dezember",
    sun: "So",
    mon: "Mo",
    tue: "Di",
    wed: "Mi",
    thu: "Do",
    fri: "Fr",
    sat: "Sa",

    amateur: "Amateur",
    semi_pro: "Semi-Profi",
    professional: "Profi",
    northern_africa: "Nordafrika",
    sub_saharan_africa: "Subsaharisches Afrika",
    eastern_africa: "Ostafrika",
    middle_africa: "Zentralafrika",
    southern_africa: "Südafrika",
    western_africa: "Westafrika",
    northern_america: "Nordamerika",
    central_america: "Zentralamerika",
    south_america: "Südamerika",
    caribbean: "Karibik",
    central_asia: "Zentralasien",
    eastern_asia: "Ostasien",
    southern_asia: "Südasien",
    south_eastern_asia: "Südostasien",
    western_asia: "Westasien",
    eastern_europe: "Osteuropa",
    northern_europe: "Nordeuropa",
    southern_europe: "Südeuropa",
    western_europe: "Westeuropa",
    australia_and_new_zealand: "Australien und Neuseeland",
    melanesia: "Melanesien",
    micronesia: "Mikronesien",
    polynesia: "Polynesien",
    selected_range:"Ausgewählter Bereich",
    total_days:"Gesamttage",
  },
  hr: {
     select_date_range: "Raspon datuma",
    create_title: "Kreiraj spremni popis",
    edit_title: "Uredi spremni popis",
    financial_information: "Financijske informacije",
    no_roster_statuses_available: "Nema dostupnih statusa popisa",
    purse: "Nagradni fond",
    purse_tooltip_title: "Odaberite očekivani ili ponuđeni raspon novčane nagrade za borbu ili priliku.",
    purse_tooltip_description: "Ovo pomaže filtrirati realistične ponude i rano postaviti očekivanja.",
    currency: "Valuta",
    select_purse_placeholder: "Odaberi novčanu nagradu",
    no_purse_options: "Nema opcija za novčanu nagradu",
    select_currency_placeholder: "Odaberi valutu",
    sport_information: "Informacije o sportu",
    sports: "Sportovi",
    sports_tooltip_title: "Odaberite borilački sport povezan s ovom karticom.",
    sports_tooltip_description: "Definira disciplinu za koju ste dostupni.",
    level: "Razina",
    level_tooltip_title: "Odaberite razinu natjecanja ili pravila koja se primjenjuju na ovu karticu.",
    level_tooltip_description: "Pomaže uskladiti borce i događaje prema razini iskustva i propisima.",
    select_sport_placeholder: "Odaberi sport",
    no_sports_available: "Nema dostupnih sportova",
    weight_class: "Težinska kategorija",
    weight_class_tooltip_title: "Odaberite težinsku kategoriju relevantnu za ovu karticu.",
    weight_class_tooltip_description: "Definira vašu borbenu kategoriju",
    select_weight_class_placeholder: "Odaberi težinsku kategoriju",
    no_weight_classes_available: "Nema dostupnih težinskih kategorija",
    valid_upto: "Vrijedi do",
    valid_upto_tooltip_title: "Pokazuje koliko dugo će ova kartica ostati aktivna i vidljiva drugim korisnicima.",
    valid_upto_tooltip_description: "Nakon isteka neće se pojavljivati u pretragama ili popisima.",
    select_valid_upto_placeholder: "Odaberi mjesec valjanosti",
    one_month: "1 mjesec",
    two_months: "2 mjeseca",
    three_months: "3 mjeseca",
    Ready_updated_success: 'Spremni popis uspješno ažuriran',
    Ready_Created_success: 'Spremni popis uspješno stvoren',
        ready_roster_deleted_success: "Spremni raspored uspješno obrisan"
,
    location_travel_availability: "Lokacija, putovanja i dostupnost",
    roster_status: "Status popisa",
    select_roster_status_placeholder: "Odaberi status popisa",
    location: "Lokacija",
    location_tooltip_title: "Prikazuje glavnu lokaciju gdje se očekuje borba ili prilika.",
    location_tooltip_description: "Koristi se za usklađivanje, planiranje putovanja i regionalnu relevantnost.",
    available_regions: "Dostupne regije",
    available_regions_tooltip_title: "Prikazuje zemlje ili regije gdje je korisnik spreman boriti se, raditi ili surađivati.",
    available_regions_tooltip_description: "Koristno za filtriranje prema geografskoj fleksibilnosti.",
    select_available_regions_placeholder: "Odaberi dostupne regije",
    notice_period_days: "Rok obavijesti (dani)",
    enter_notice_period_placeholder: "Unesi rok obavijesti",
    travel_ready: "Spreman za putovanje?",
    available_days: "Dostupni dani",
    dates: "datum",
    selected: "odabran",
    additional_information: "Dodatne informacije",
    notes: "Bilješke",
    enter_notes_placeholder: "Unesi dodatne bilješke...",
    characters: "1000 znakova",
    cancel: "Otkaži",
    save: "Spremi",
    purse_required: "Novčana nagrada je obavezna",
    currency_required: "Valuta je obavezna",
    sport_required: "Sport je obavezan",
    level_required: "Razina je obavezna",
    weight_class_required: "Težinska kategorija je obavezna",
    valid_upto_required: "Datum valjanosti je obavezan",
    valid_upto_future: "Datum valjanosti mora biti u budućnosti",
    location_required: "Lokacija je obavezna",
    available_regions_required: "Mora biti odabrana barem jedna regija",
    available_days_required: "Mora biti odabran barem jedan dan",
    roster_status_required: "Status popisa je obavezan",
    failed_load_dropdown_data: "Neuspjelo učitavanje podataka za padajući izbornik",
    failed_load_initial_data: "Neuspjelo učitavanje početnih podataka",
    failed_load_purse_options: "Neuspjelo učitavanje opcija novčane nagrade",
    failed_load_training_disciplines: "Neuspjelo učitavanje trening disciplina",
    failed_load_weight_classes: "Neuspjelo učitavanje težinskih kategorija",
    failed_load_currency_options: "Neuspjelo učitavanje opcija valuta",
    failed_save_roster: "Neuspjelo spremanje popisa",
    january: "Siječanj",
    february: "Veljača",
    march: "Ožujak",
    april: "Travanj",
    may: "Svibanj",
    june: "Lipanj",
    july: "Srpanj",
    august: "Kolovoz",
    september: "Rujan",
    october: "Listopad",
    november: "Studeni",
    december: "Prosinac",
    sun: "Ned",
    mon: "Pon",
    tue: "Uto",
    wed: "Sri",
    thu: "Čet",
    fri: "Pet",
    sat: "Sub",
    amateur: "Amater",
    semi_pro: "Polu-Pro",
    professional: "Profesionalac",
    northern_africa: "Sjeverna Afrika",
    sub_saharan_africa: "Subsaharska Afrika",
    eastern_africa: "Istočna Afrika",
    middle_africa: "Središnja Afrika",
    southern_africa: "Južna Afrika",
    western_africa: "Zapadna Afrika",
    northern_america: "Sjeverna Amerika",
    central_america: "Središnja Amerika",
    south_america: "Južna Amerika",
    caribbean: "Karibi",
    central_asia: "Središnja Azija",
    eastern_asia: "Istočna Azija",
    southern_asia: "Južna Azija",
    south_eastern_asia: "Jugoistočna Azija",
    western_asia: "Zapadna Azija",
    eastern_europe: "Istočna Europa",
    northern_europe: "Sjeverna Europa",
    southern_europe: "Južna Europa",
    western_europe: "Zapadna Europa",
    australia_and_new_zealand: "Australija i Novi Zeland",
    melanesia: "Melanezija",
    micronesia: "Mikronezija",
    polynesia: "Polinezija",
    select_level_placeholder: 'Odaberite razinu',
    selected_range:"Odabrani raspon",
    total_days:"Ukupni dani",
  },
};